import React from 'react';
import { Button } from '@clearcover/atlas';

import { Column, Row } from 'Shared/components';

import styles from './styles.module.css';

type InlineEditRowProps = {
  label: string;
  displayValue: React.ReactNode;
  isEditing: boolean;
  isSubmitting: boolean;
  isValid: boolean;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  editContent: React.ReactNode;
  editButtonTestId: string;
  cancelButtonTestId: string;
};

export const InlineEditRow = ({
  label,
  displayValue,
  isEditing,
  isSubmitting,
  isValid,
  onEdit,
  onSave,
  onCancel,
  editContent,
  editButtonTestId,
  cancelButtonTestId,
}: InlineEditRowProps) => (
  <Row className={styles.contactInfoRow}>
    <Column className={styles.contactInfoFormColumn}>
      <div className={styles.contactInfoLabel}>{label}</div>
    </Column>
    <Column className={styles.contactInfoFormColumn}>
      {isEditing ? editContent : displayValue}
    </Column>
    <Column className={styles.contactInfoFormColumn}>
      {isEditing && (
        <Button
          link
          size="md"
          className={styles.contactInfoEditButton}
          onClick={onCancel}
          disabled={isSubmitting}
          data-testid={cancelButtonTestId}
        >
          Cancel
        </Button>
      )}
      <Button
        link
        size="md"
        className={styles.contactInfoEditButton}
        disabled={isEditing && (isSubmitting || !isValid)}
        isSubmitting={isEditing && isSubmitting}
        onClick={isEditing ? onSave : onEdit}
        type={isEditing ? 'submit' : 'button'}
        data-testid={editButtonTestId}
      >
        {isEditing ? 'Save' : 'Edit'}
      </Button>
    </Column>
  </Row>
);
